<template>
    <div class="loader" :class="{ 'loader--inline': inline }">
        <svg width="54" height="6" viewBox="0 0 54 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.2" d="M3 0L0 3L3 6L6 3L3 0Z" fill="black">
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
                    repeatCount="indefinite"
                    values="0.2;1;0.2;0.2"
                    keyTimes="0;0.3;0.6;1"
                    dur="1s"
                    begin="-0.6s"></animate>
            </path>
            <path opacity="0.2" d="M27 0L24 3L27 6L30 3L27 0Z" fill="black">
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
                    repeatCount="indefinite"
                    values="0.2;1;0.2;0.2"
                    keyTimes="0;0.3;0.6;1"
                    dur="1s"
                    begin="-0.39999999999999997s"></animate>
            </path>
            <path d="M51 0L48 3L51 6L54 3L51 0Z" fill="black">
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
                    repeatCount="indefinite"
                    values="0.2;1;0.2;0.2"
                    keyTimes="0;0.3;0.6;1"
                    dur="1s"
                    begin="-0.19999999999999998s"></animate>
            </path>
        </svg>
    </div>
</template>
<script>
export default {
    name: "Loader",
    props: {
        inline: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="less" scoped>
.loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    &--inline {
        position: static;
        transform: none;
        left: 0;
        top: 0;
    }
}
</style>
